import { Page } from "@iq/models";

function Quotes() {
	return (
		<Page>
		</Page>
	);
}


export default Quotes;